import Select from '../Select';

export default function HtmlInspectorSelect({ value, options, onChange, disabled = false }) {
    // React portal events still bubble through this wrapper. Keep interactions
    // in the inspector from reaching the canvas' outside-click deselection.
    return <div onMouseDown={event => event.stopPropagation()}>
        <Select appearance="modern" portal disabled={disabled}
        options={options}
        selected={options.find(option => option.value === value) || { id: value, value, name: String(value || 'Predefinito') }}
        onSelect={option => onChange(option.value)} />
    </div>;
}
